import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { getConfig } from '../../../../../../ApiHelpers/ApiDefaultConfig';
import { updateUserInPromo } from '../../../../Api/LoadPanel/LoadPanel';

interface Props {
    show: boolean
    handleClose: () => void
    playerInfo: any
    quantityToLoad: number
}

export const CompletePlayerInfoModal = ({ show, handleClose, playerInfo, quantityToLoad }: Props) => {
    const [loading, setLoading] = useState(false)
    const [playerForm, setPlayerForm] = useState({
        phone: '',
        platformUser: playerInfo?.platformUser,
        firstName: '',
        lastName: '',
        playerId: playerInfo?.id,
        firstLoadValue: quantityToLoad
    })

    const inputhandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPlayerForm({ ...playerForm, [e.target.name]: e.target.value })
    }

    const submit = async () => {
        setLoading(true)

        const payload = {
            ...playerForm,
            firstLoadValue: Number(playerForm.firstLoadValue)
        }

        try {
            await updateUserInPromo(payload)
            Swal.fire({
                text: 'Hecho.',
                icon: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                timer: 500
            })

            handleClose()
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        setPlayerForm({ ...playerForm, platformUser: playerInfo?.platformUser ?? '', firstLoadValue: quantityToLoad ?? 0 })
    }, [playerInfo])


    return (
        <Modal show={show} onHide={handleClose} size='lg' backdrop="static" keyboard={false} centered>
            <div className='p-4'>

                <Modal.Body>
                    <Modal.Title>Completa Información Requerida</Modal.Title>
                    <div className="mt-4">
                        <p>El usuario <span className='text-success'>{playerInfo?.platformUser}</span> fue creado en <span className='text-success'>Promoción</span> y no tiene un número de teléfono asignado. Debes asignarlo.</p>
                    </div>

                    <div className="mb-2">
                        <label htmlFor="firstLoadValue">Valor primera carga <span className='text-danger'>*</span></label>
                        <input value={playerForm.firstLoadValue ?? ''} onChange={inputhandler} name='firstLoadValue' type="number" className="form-control mx-0 customDarkInput" placeholder="Valor primera carga" aria-label="Recipient's firstLoadValue" aria-describedby="basic-addon2" />
                    </div>

                    <div className="mb-2">
                        <label htmlFor="phone">Número de teléfono <span className='text-danger'>*</span></label>
                        <input value={playerForm.phone} onChange={inputhandler} name='phone' type="text" className="form-control mx-0 customDarkInput" placeholder="Teléfono" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                    </div>

                    <div className="mb-2">
                        <label htmlFor="firstName">Nombre</label>
                        <input value={playerForm.firstName} onChange={inputhandler} name='firstName' type="text" className="form-control mx-0 customDarkInput" placeholder="Nombre" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="lastName">Apellido</label>
                        <input value={playerForm.lastName} onChange={inputhandler} name='lastName' type="text" className="form-control mx-0 customDarkInput" placeholder="Apellido" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                    </div>

                </Modal.Body>
                <div className='d-flex justify-content-end'>
                    <Button variant="primary" disabled={loading || playerForm.phone.length < 5} onClick={submit}>
                        {loading ? 'Guardando...' : 'Guardar'}
                    </Button>
                </div>
            </div>
        </Modal>

    );
}
